import {
    CommentType,
    CreateMessageBody,
    GetMessageParams,
    UploadFileType,
} from '../models/comments'
import { http } from '../Techedge-digitalportal-shared'

const b64toBlob = (b64Data, contentType?, sliceSize?) => {
    contentType = contentType || ''
    sliceSize = sliceSize || 512
    var byteCharacters = atob(b64Data)
    var byteArrays = []
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)
        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
        }
        var byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
    }
    var blob = new Blob(byteArrays, { type: contentType })
    return blob
}
export class CommentsService {
    static BASE_URL: string = process.env.SMARTLY_BASE_URL_BE
    static FORUM_URL: string = CommentsService.BASE_URL + '/forumsapi'
    static ATTACHMENTS_URL: string =
        CommentsService.BASE_URL + `/attachmentsapi`

    static headersObj = {
        headers: {
            'Accept-Language': '',
        },
        timeout: 180000,
    }

    static CreateMessage = (body: CreateMessageBody, type: CommentType) => {
        return http.post<any>(
            `${CommentsService.FORUM_URL}/${type}/message`,
            { ...body },
            CommentsService.headersObj
        )
    }
    static EditMessage = (
        body: CreateMessageBody,
        id: string,
        type: CommentType
    ) => {
        return http.put<any>(
            `${CommentsService.FORUM_URL}/${type}/message/${id}`,
            { ...body },
            CommentsService.headersObj
        )
    }
    static ReactionMessage = (
        body: Partial<CreateMessageBody>,
        id: string,
        type: CommentType
    ) => {
        return http.put<any>(
            `${CommentsService.FORUM_URL}/${type}/message/reaction/${id}`,
            { ...body },
            CommentsService.headersObj
        )
    }
    static DeleteMessage = (
        id: string,
        body: GetMessageParams,
        type: CommentType
    ) => {
        return http.delete<any>(
            `${CommentsService.FORUM_URL}/${type}/message/${id}`,
            {
                ...CommentsService.headersObj,
                params: body,
            }
        )
    }
    static GetMessageList = (params: GetMessageParams, type: CommentType) => {
        if (!params.isDetail) {
            delete params.isDetail
        }
        return http.get<any>(`${CommentsService.FORUM_URL}/${type}/messages`, {
            ...CommentsService.headersObj,
            params,
        })
    }
    static UploadFile = (
        file: any,
        type: UploadFileType,
        fileName: string,
        contentType: string,
        commentType: CommentType
    ) => {
        const formData = new FormData()
        var splittedB64 = file.split(',')[1]
        var blob = b64toBlob(splittedB64, contentType)
        formData.append('file', blob, fileName)
        formData.append('type', type)
        formData.append('attachmentType', commentType + 'message')
        return http.post<any>(
            `${CommentsService.ATTACHMENTS_URL}/${commentType}/upload`,
            formData,
            {
                ...CommentsService.headersObj,
                headers: {
                    ...CommentsService.headersObj.headers,
                    'Content-Type': 'multipart/form-data',
                },
            }
        )
    }
}
